export default "__VITE_ASSET__Cutzi4cn__";